module.exports = __webpack_public_path__ + "static/media/ic_github.094b9741.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ic_github.svg
// module id = 156
// module chunks = 0